const Index = () => import("@/views/express/index");
const Adv = () => import("@/views/express/adv");

const routes = [
    {
        path: "/express/notify",
        name: "notify",
        meta: {
            title: "存件提示"
        },
        component: Index
    },
    {
        path: "/express/adv",
        name: "adv",
        meta: {
            title: "闪光快递柜"
        },
        component: Adv
    },
];
export default routes;
